/**
 *--------------- AUTHENTICATION EVENTS ---------------
 */

/**
 * Event triggered when verification code is entered
 */
export const verificationCodeEntered = 'verificationCodeEntered'

/**
 * Event triggered when a user enters in their email or phone number to begin the signup or login process
 */
export const signupLoginEmailPhoneEntered = 'signupLoginEmailPhoneEntered'

/**
 * Event triggered when a user enters in their name during the onboarding process
 */
export const userNameEntered = 'userNameEntered'

/**
 *--------------- POST EVENTS ---------------
 */

/**
 * Event triggered when a user creates a post
 */
export const postCreated = 'postCreated'

/**
 * Event triggered when a user edits a post
 */
export const postEdited = 'postEdited'

/**
 * Event triggered when a user clicks on the view loadboard button and modal opens
 */
export const loadboardOpened = 'loadboardOpened'

/**
 * Event triggered once a user submits an offer
 */
export const postOfferSubmitted = 'postOfferSubmitted'

/**
 *--------------- SHIPMENT EVENTS ---------------
 */

/**
 * Event triggered when a user adds a stop in the shipment
 */
export const stopAdded = 'stopAdded'

/**
 * Event triggered when a user adds a stop ETA in the shipment
 */
export const stopETAUpdated = 'stopETAUpdated'

/**
 * Event triggered when a user removes a stop from the shipment
 */
export const stopRemoved = 'stopRemoved'

/**
 *--------------- WORKSPACE EVENTS ---------------
 */

/**
 * Event triggered once a user verifies the workspace.
 */
export const workspaceVerified = 'workspaceVerified'

/**
 *--------------- NETWORK EVENTS ---------------
 */

/**
 * Event triggered when a user sends an email to someone from their network
 */
export const emailSentToNetwork = 'emailSentToNetwork'
